export enum JackpotInternalId {
    Daily = 8000,
    Twilight = 8001,
    HourlyCaptain8 = 8002
}

export enum JackpotType {
    Daily = "Daily",
    HighNoon = "HighNoon",
    Twilight = "Twilight",
    Party = "Party",
    HourlyCaptain8 = "HourlyCaptain8"
}

export enum JACKPOT_STATE {
    Cold = 1,
    Regular = 2,
    Hot = 3,
    OffHours = 4 // used only for Hourly Party Jackpots for now
}
